<template>
  <div class="moe_page flex Flexalign flexcolumn">
    <!-- <moe-top></moe-top> -->
    <slot></slot>
  </div>
</template>

<script>
// import moeTop from './moeTop.vue';
export default {
  components: {
    // moeTop
  },
  name: "moePage",
};
</script>

<style lang="scss" scoped>
.moe_page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}
// 电脑适配
@media (min-width: 1200px) {
  .moe_page {
    position: relative;
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
  }
}
</style>
